var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounPlumbing3503103(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-plumbing-3503103",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.769,
    height: 38.748,
    viewBox: "0 0 37.769 38.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M94.262,18.532A1.038,1.038,0,0,1,95.294,17.5h7.97a1.032,1.032,0,1,1,0,2.063h-7.97A1.034,1.034,0,0,1,94.262,18.532ZM131,28.881h0a1.033,1.033,0,0,0-1.032,1.031v7.971a1.032,1.032,0,1,0,2.063,0V29.912A1.037,1.037,0,0,0,131,28.881ZM110.57,41.115h6.715a3.962,3.962,0,0,1,3.962-3.857h8.062V30.543h-8.062A10.689,10.689,0,0,0,110.57,41.115Zm7.34.657h-7.963a1.051,1.051,0,0,0-.736.3,1.018,1.018,0,0,0-.3.729,1.039,1.039,0,0,0,1.038,1.032h7.963a1.007,1.007,0,0,0,.729-.3,1.031,1.031,0,0,0-.729-1.761Zm-7.34,3.818a3.966,3.966,0,1,1-7.931,0v-10H95.924V45.6a10.677,10.677,0,0,0,21.355,0v-1.1H110.57Zm-6.577-10.96a1.015,1.015,0,0,0,.3-.723,1.04,1.04,0,0,0-1.038-1.038H95.294a1.017,1.017,0,0,0-.723.3,1.05,1.05,0,0,0-.3.736,1.026,1.026,0,0,0,1.025,1.025h7.963a1.049,1.049,0,0,0,.736-.3Zm-1.354-2.418V20.22H95.924V32.213Z",
    transform: "translate(-94.262 -17.5)",
    fill: "#0f8a45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounPlumbing3503103);
export default __webpack_public_path__ + "static/media/noun-plumbing-3503103.3163c2edea0c4d97705c72d110cc7100.svg";
export { ForwardRef as ReactComponent };